module.exports = __webpack_public_path__ + "img/tips1.8116a469.png";